---
meta:
  - title: Historial de facturación - IUSPRO Docs
  - description: Aprende a ver tu historial de facturación y pagos.
---

# Ver historial de facturación

<a href="/settings/facturacion" target="_blank">Ir a Facturación →</a>

En el historial de facturación puedes revisar todos tus pagos y transacciones realizadas en IUSPRO.

## Cómo acceder

1. Haz clic en tu **nombre o email** en la esquina inferior izquierda
2. Selecciona **"Preferencias"**
3. Ve a la pestaña **"Facturación"**
4. Desplázate hasta la sección **"Historial de Facturación"**

## Información disponible

En el historial verás:

- **Descripción** del cargo (suscripción mensual, paquete adicional, etc.)
- **Fecha** de la transacción
- **Monto** cobrado
- **Tipo** de cargo (Suscripción o Compra única)
- **Estado de factura electrónica** (si fue generada o está pendiente)
